import React from 'react'

const ListBig = (props) => {
  const { data } = props
  return (
    <div className={'grid-list'}>

      {data.map((i) => <a className={'grid-item'} href={"/images/" + i.images[0] }>
        <figure><img src={"/images/new/" + i.images[0] } alt="" /></figure>
        <span className={'date'}>{i.year}</span>
        <span className={'name'}>{i.name}</span>
        <span className={'desc1'}>
          {i.description1.split('\n').map((item, key) => {
            return <React.Fragment key={key}>{item}<br/></React.Fragment>
          })}</span>
        <span className={'desc2'}>{i.description2}</span>
      </a>)}
    </div>
  )
}

export default ListBig